import { render } from "./PaymentFailView.vue?vue&type=template&id=c5565048&scoped=true&ts=true"
import script from "./PaymentFailView.vue?vue&type=script&lang=ts"
export * from "./PaymentFailView.vue?vue&type=script&lang=ts"

import "./PaymentFailView.vue?vue&type=style&index=0&id=c5565048&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5565048"]])

export default __exports__